module.exports = __webpack_public_path__ + "img/_send.83224494.svg";